import { TypeOptions } from "react-toastify/dist/types";
import { toast } from "react-toastify";

export const NOTIFICATION_TYPES = {
  ...toast.TYPE,
};

export enum NotificationContext {
  Contextual = "contextual",
  System = "system",
}

export enum NotificationTypes {
  Error = "error",
  Warning = "warning",
  Success = "success",
  Info = "info",
}

export const ADD_NOTIFICATION = "[NOTIFICATION] ADD_NOTIFICATION";
export const DISMISS_NOTIFICATION = "[NOTIFICATION] DISMISS_NOTIFICATION";
export const REMOVE_ALL_CONTEXTUAL_NOTIFICATIONS =
  "[NOTIFICATION] REMOVE ALL CONTEXTUAL";
export const ADD_SESSION_EXP_NOTIFICATION =
  "[NOTIFICATION] ADD_SESSION_EXP_NOTIFICATION";

export type FormattedMessageValues = string | number;

export interface NotificationMessageOptions {
  values?: Record<string, FormattedMessageValues>;
  title?: string;
}

export interface NotificationOptionsAction extends NotificationMessageOptions {
  context?: NotificationContext;
}

export interface AddNotificationPayload extends NotificationOptionsAction {
  id: string;
  type: TypeOptions;
}

export interface AddNotificationAction {
  type: typeof ADD_NOTIFICATION;
  payload: AddNotificationPayload;
}

interface AddSessionExpNotificationAction {
  type: typeof ADD_SESSION_EXP_NOTIFICATION;
  payload: AddNotificationPayload;
}

interface RemoveNotificationAction {
  type: typeof DISMISS_NOTIFICATION;
  payload: string;
}

interface RemoveAllContextual {
  type: typeof REMOVE_ALL_CONTEXTUAL_NOTIFICATIONS;
}

export type NotificationActionTypes =
  | AddNotificationAction
  | RemoveNotificationAction
  | RemoveAllContextual
  | AddSessionExpNotificationAction;
